var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"selectIndex":2}},[_c('carousel'),_c('div',{staticClass:"rwt-portfolio-area rn-section-gap"},[_c('div',{staticClass:"container"},[_c('Sponsor')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }